import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryContactUpdateFailedAction = {
	type: 'BENEFICIARY_CONTACT_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryContactUpdateFailedAction => ({
	type: 'BENEFICIARY_CONTACT_UPDATE_FAILED',
	payload,
});
